/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  GetOrganizationsTeam200Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    GetOrganizationsTeam200ResponseFromJSON,
    GetOrganizationsTeam200ResponseToJSON,
} from '../models';

export interface GetOrganizationsTeamRequest {
    slashIDOrgID: string;
}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI {

    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */
    async getOrganizationsTeamRaw(requestParameters: GetOrganizationsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationsTeam200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getOrganizationsTeam.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/team`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationsTeam200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */
    async getOrganizationsTeam(requestParameters: GetOrganizationsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationsTeam200Response> {
        const response = await this.getOrganizationsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
